import './App.css';
import React, { useState, useEffect } from 'react';
import MainNav from './components/navbars/mainNav';
import NavbarPhone from './components/navbars/navbarPhone';
import { AboutABP } from './components/sections/spanish/about';
import { ClientsABP } from './components/sections/spanish/clients';
import { Footer } from './components/misc/footer';
import { Gallery } from './components/sections/spanish/gallery';
import { SecondGallery } from './components/sections/spanish/second-gallery';
import { AvailableWorks } from './components/sections/spanish/availableWorks';
import { ThirdGallery } from './components/sections/spanish/thirdGallery';
import { Providers } from './components/sections/spanish/providers';

function Sapp() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <main>
      <header id='beginning'>
        {isMobile ? (
          <NavbarPhone></NavbarPhone>
        ) :
          (
            <MainNav></MainNav>
          )}
        <h1>ANFRO</h1>
      </header>
      <section id='about'>
        <AboutABP></AboutABP>
      </section>
      <section id='gallery'>
        <Gallery></Gallery>
      </section>
      <section id='works'>
        <AvailableWorks></AvailableWorks>
      </section>
      <section>
        <ThirdGallery></ThirdGallery>
      </section>
      <section id='clients'>
        <ClientsABP></ClientsABP>
      </section>
      <section id='second-gallery'>
        <SecondGallery></SecondGallery>
      </section>
      <section id='providers'>
          <Providers></Providers>
      </section>
      <section id='footer'>
        <Footer></Footer>
      </section>
    </main>
  );
}

export default Sapp;
